import { getActionList } from 'redux/actions/action-utils';
import actions from 'redux/actions/expectationManagementActions';
import { caseProviderTypes } from 'constants/case';

const actionList = getActionList(actions);
export type ExpectationManagementActionType = typeof actionList[number];

export type ProviderType = keyof typeof caseProviderTypes;

export type ExpectationManagementState = {
  cases: string[];
};

export type ExpectationManagementHook = {
  estimatedTime: string;
  estimatedProvidersTypes: ProviderType[];
  showExpectationManagementModal: boolean;
  addExpectationManagementCase: () => void;
};

export enum ShowExpectationManagementEnum {
  NEVER = 'never',
  ONCE = 'once',
  ALWAYS = 'always',
}
